import { Box } from '@domain-group/suit-theme'

import { ImageModel } from '@models/types'

import ImageListItem from '../../ImageListItem'

type ListViewProps = {
  images: ImageModel[],
}

const ListView = (props: ListViewProps) => {
  const { images } = props

  return (
    <Box flexDirection="column">
      {images.map(image => <ImageListItem image={image} key={image.id} />)}
    </Box>
  )
}

export default ListView
